import { render, staticRenderFns } from "./YouTubeIcon.vue?vue&type=template&id=43ae9b21"
import script from "./YouTubeIcon.vue?vue&type=script&lang=js"
export * from "./YouTubeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports